<template>
  <div
    class="flex flex-col w-full bg-fixed bg-cover bg-no-repeat bg-top"
    :style="{
    backgroundImage: `url(${backgroundImg})`
  }"
  >
    <header class="w-full bg-white shadow-md">
      <div class="container">
        <div class="flex items-center w-full">
          <div class="py-3">
            <router-link to="/" class>
              <img
                v-if="isShowLogo"
                src="../../../public/logo.svg"
                class="hidden md:block me-1 h-10"
              />
              <img
                src="../../../public/logo.png"
                class="me-1 h-10"
                :class="show_mini_nav ? 'hidden' : 'md:hidden'"
              />
            </router-link>
          </div>
          <div class="flex-1">
            <!-- login btn lg-->
            <transition name="fade">
              <div class="nav-item dropdown-pull-right" v-if="!$user && !show_mini_nav">
                <button class="btn btn-pri" @click="actionLogin()">
                  {{
                  $user
                  ? lang === "vi"
                  ? "Đăng xuất"
                  : "Logout"
                  : lang === "vi"
                  ? "Đăng nhập/Đăng ký"
                  : "Sign up/Sign in"
                  }}
                </button>
              </div>
            </transition>

            <!-- account lg-->
            <transition name="fade">
              <div class="nav-item dropdown dropdown-pull-right" v-if="$user && !show_mini_nav">
                <a
                  class="nav-link dropdown-toggle p-0"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    v-if="!$user.avatar"
                  >
                    <g clip-path="url(#clip0_14074_11748)">
                      <circle cx="19.9856" cy="19.9856" r="19.9856" fill="#476DD6" />
                      <path
                        d="M19.9848 8.32715C15.1739 8.32715 11.2627 12.2589 11.2627 17.0952C11.2627 21.8391 14.9535 25.6786 19.7644 25.8447C19.9113 25.8262 20.0582 25.8262 20.1684 25.8447C20.2051 25.8447 20.2235 25.8447 20.2602 25.8447C20.2786 25.8447 20.2786 25.8447 20.2969 25.8447C24.9977 25.6786 28.6885 21.8391 28.7068 17.0952C28.7068 12.2589 24.7957 8.32715 19.9848 8.32715Z"
                        fill="white"
                      />
                      <path
                        d="M29.3146 30.7547C24.1916 27.3213 15.8367 27.3213 10.6769 30.7547C8.34493 32.3237 7.05957 34.4465 7.05957 36.717C7.05957 38.9874 8.34493 41.0917 10.6586 42.6423C13.2293 44.3774 16.6079 45.245 19.9866 45.245C23.3653 45.245 26.7439 44.3774 29.3146 42.6423C31.6283 41.0733 32.9136 38.969 32.9136 36.68C32.8953 34.4096 31.6283 32.3053 29.3146 30.7547Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_14074_11748">
                        <rect width="40" height="40" rx="19.9856" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <img
                    :src="$user && $user.avatar && getImageURL($user.avatar)"
                    alt
                    class="avatar"
                    v-if="$user && $user.avatar"
                  />
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black"
                      href="javascript:;"
                      @click="goToInfo()"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="me-2"
                      >
                        <path
                          d="M12.1605 10.87C12.0605 10.86 11.9405 10.86 11.8305 10.87C9.45055 10.79 7.56055 8.84 7.56055 6.44C7.56055 3.99 9.54055 2 12.0005 2C14.4505 2 16.4405 3.99 16.4405 6.44C16.4305 8.84 14.5405 10.79 12.1605 10.87Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.1607 14.56C4.7407 16.18 4.7407 18.82 7.1607 20.43C9.9107 22.27 14.4207 22.27 17.1707 20.43C19.5907 18.81 19.5907 16.17 17.1707 14.56C14.4307 12.73 9.9207 12.73 7.1607 14.56Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Thông tin cá nhân
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black"
                      href="javascript:;"
                      @click="goToLanding()"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="me-2"
                      >
                        <path
                          d="M12.62 20.8096C12.28 20.9296 11.72 20.9296 11.38 20.8096C8.48 19.8196 2 15.6896 2 8.68961C2 5.59961 4.49 3.09961 7.56 3.09961C9.38 3.09961 10.99 3.97961 12 5.33961C13.01 3.97961 14.63 3.09961 16.44 3.09961C19.51 3.09961 22 5.59961 22 8.68961C22 15.6896 15.52 19.8196 12.62 20.8096Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.3457 10.6801H7.96963C8.71963 10.6801 9.55963 11.2501 9.83963 11.9501L10.9796 14.8301C11.2396 15.4801 11.6496 15.4801 11.9096 14.8301L14.1996 9.02011C14.4196 8.46011 14.8296 8.44011 15.1096 8.97011L16.1496 10.9401C16.4596 11.5301 17.2596 12.0101 17.9196 12.0101H21.4997"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Hồ Sơ Sức Khỏe
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToHR()">
                      <svg
                        class="me-2"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 14.7385H8C7.73478 14.7385 7.48043 14.8439 7.29289 15.0314C7.10536 15.219 7 15.4733 7 15.7385C7 16.0037 7.10536 16.2581 7.29289 16.4456C7.48043 16.6332 7.73478 16.7385 8 16.7385H16C16.2652 16.7385 16.5196 16.6332 16.7071 16.4456C16.8946 16.2581 17 16.0037 17 15.7385C17 15.4733 16.8946 15.219 16.7071 15.0314C16.5196 14.8439 16.2652 14.7385 16 14.7385ZM16 10.7385H10C9.73478 10.7385 9.48043 10.8439 9.29289 11.0314C9.10536 11.219 9 11.4733 9 11.7385C9 12.0037 9.10536 12.2581 9.29289 12.4456C9.48043 12.6332 9.73478 12.7385 10 12.7385H16C16.2652 12.7385 16.5196 12.6332 16.7071 12.4456C16.8946 12.2581 17 12.0037 17 11.7385C17 11.4733 16.8946 11.219 16.7071 11.0314C16.5196 10.8439 16.2652 10.7385 16 10.7385ZM20 4.73853H17V3.73853C17 3.47331 16.8946 3.21895 16.7071 3.03142C16.5196 2.84388 16.2652 2.73853 16 2.73853C15.7348 2.73853 15.4804 2.84388 15.2929 3.03142C15.1054 3.21895 15 3.47331 15 3.73853V4.73853H13V3.73853C13 3.47331 12.8946 3.21895 12.7071 3.03142C12.5196 2.84388 12.2652 2.73853 12 2.73853C11.7348 2.73853 11.4804 2.84388 11.2929 3.03142C11.1054 3.21895 11 3.47331 11 3.73853V4.73853H9V3.73853C9 3.47331 8.89464 3.21895 8.70711 3.03142C8.51957 2.84388 8.26522 2.73853 8 2.73853C7.73478 2.73853 7.48043 2.84388 7.29289 3.03142C7.10536 3.21895 7 3.47331 7 3.73853V4.73853H4C3.73478 4.73853 3.48043 4.84388 3.29289 5.03142C3.10536 5.21896 3 5.47331 3 5.73853V19.7385C3 20.5342 3.31607 21.2972 3.87868 21.8598C4.44129 22.4225 5.20435 22.7385 6 22.7385H18C18.7956 22.7385 19.5587 22.4225 20.1213 21.8598C20.6839 21.2972 21 20.5342 21 19.7385V5.73853C21 5.47331 20.8946 5.21896 20.7071 5.03142C20.5196 4.84388 20.2652 4.73853 20 4.73853V4.73853ZM19 19.7385C19 20.0037 18.8946 20.2581 18.7071 20.4456C18.5196 20.6332 18.2652 20.7385 18 20.7385H6C5.73478 20.7385 5.48043 20.6332 5.29289 20.4456C5.10536 20.2581 5 20.0037 5 19.7385V6.73853H7V7.73853C7 8.00374 7.10536 8.2581 7.29289 8.44563C7.48043 8.63317 7.73478 8.73853 8 8.73853C8.26522 8.73853 8.51957 8.63317 8.70711 8.44563C8.89464 8.2581 9 8.00374 9 7.73853V6.73853H11V7.73853C11 8.00374 11.1054 8.2581 11.2929 8.44563C11.4804 8.63317 11.7348 8.73853 12 8.73853C12.2652 8.73853 12.5196 8.63317 12.7071 8.44563C12.8946 8.2581 13 8.00374 13 7.73853V6.73853H15V7.73853C15 8.00374 15.1054 8.2581 15.2929 8.44563C15.4804 8.63317 15.7348 8.73853 16 8.73853C16.2652 8.73853 16.5196 8.63317 16.7071 8.44563C16.8946 8.2581 17 8.00374 17 7.73853V6.73853H19V19.7385Z"
                          fill="#5D5D5D"
                        />
                      </svg>
                      Sổ khám bệnh
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black"
                      href="javascript:;"
                      @click="goToCircle()"
                    >
                      <svg
                        class="me-2"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.87868 14.6213C11.0503 15.7929 12.9497 15.7929 14.1213 14.6213C15.2929 13.4497 15.2929 11.5502 14.1213 10.3786C12.9497 9.20707 11.0503 9.20707 9.87868 10.3786C8.70711 11.5502 8.70711 13.4497 9.87868 14.6213Z"
                          fill="currentColor"
                        />
                        <circle cx="3.99974" cy="12.4997" r="2.99974" fill="#5D5D5D" />
                        <path
                          d="M15 4.5C15 6.15685 13.6569 7.5 12 7.5C10.3431 7.5 9 6.15685 9 4.5C9 2.84315 10.3431 1.5 12 1.5C13.6569 1.5 15 2.84315 15 4.5Z"
                          fill="currentColor"
                        />
                        <path
                          d="M15 20.5C15 22.1569 13.6569 23.5 12 23.5C10.3431 23.5 9 22.1569 9 20.5C9 18.8431 10.3431 17.5 12 17.5C13.6569 17.5 15 18.8431 15 20.5Z"
                          fill="currentColor"
                        />
                        <circle cx="19.9997" cy="12.5002" r="2.99974" fill="currentColor" />
                      </svg>
                      Circle
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black"
                      href="javascript:;"
                      @click="$router.push({ name: 'Orders' })"
                    >
                      <i class="el-icon-shopping-cart-full text-2xl mr-1 align-middle" />
                      Đơn hàng
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black"
                      href="javascript:;"
                      @click="actionLogin()"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="me-2"
                      >
                        <path
                          d="M9 3.93552C10.205 3.33671 11.5632 3 13 3C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21C11.5632 21 10.205 20.6633 9 20.0645"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11 12.75C11.4142 12.75 11.75 12.4142 11.75 12C11.75 11.5858 11.4142 11.25 11 11.25L11 12.75ZM1.46967 11.4697C1.17678 11.7626 1.17678 12.2374 1.46967 12.5303L6.24264 17.3033C6.53553 17.5962 7.01041 17.5962 7.3033 17.3033C7.59619 17.0104 7.59619 16.5355 7.3033 16.2426L3.06066 12L7.3033 7.75736C7.59619 7.46447 7.59619 6.98959 7.3033 6.6967C7.01041 6.40381 6.53553 6.40381 6.24264 6.6967L1.46967 11.4697ZM11 11.25L2 11.25L2 12.75L11 12.75L11 11.25Z"
                          fill="#292D32"
                        />
                      </svg>
                      Đăng xuất
                    </a>
                  </li>
                </ul>
              </div>
            </transition>

            <!-- language -->
            <transition name="fade">
              <div class="nav-item dropdown dropdown-pull-right trans-fade" v-if="!show_mini_nav">
                <a
                  class="nav-link dropdown-toggle fs-16 fw-500 d-flex align-items-center"
                  style="padding: 0.5rem 0 !important"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="me-1"
                  >
                    <path
                      d="M13 23C18.5228 23 23 18.5228 23 13C23 7.47715 18.5228 3 13 3C7.47715 3 3 7.47715 3 13C3 18.5228 7.47715 23 13 23Z"
                      stroke="#5D5D5D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.99961 4H9.99961C8.04961 9.84 8.04961 16.16 9.99961 22H8.99961"
                      stroke="#5D5D5D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 4C17.95 9.84 17.95 16.16 16 22"
                      stroke="#5D5D5D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4 17V16C9.84 17.95 16.16 17.95 22 16V17"
                      stroke="#5D5D5D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4 9.99998C9.84 8.04998 16.16 8.04998 22 9.99998"
                      stroke="#5D5D5D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="d-none d-sm-flex">
                    {{
                    lang === "vi" ? "Tiếng Việt" : "English"
                    }}
                  </span>
                  <span class="d-sm-none">{{ lang === "vi" ? "VI" : "EN" }}</span>

                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ms-1"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.2071 9.79289C15.8166 9.40237 15.1834 9.40237 14.7929 9.79289L12 12.5858L9.20711 9.79289C8.81658 9.40237 8.18342 9.40237 7.79289 9.79289C7.40237 10.1834 7.40237 10.8166 7.79289 11.2071L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L16.2071 11.2071C16.5976 10.8166 16.5976 10.1834 16.2071 9.79289Z"
                      fill="#777E91"
                    />
                  </svg>
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black"
                      href="javascript:;"
                      @click="changeLang('vi')"
                    >Tiếng Việt</a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item fs-16 txt-black blocked"
                      href="javascript:;"
                      @click="changeLang('en')"
                    >English</a>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </header>
    <div class="flex flex-1 w-full" v-if="circles !== null">
      <div v-if="step === 1" class="flex w-full py-4">
        <div class="container my-auto transform">
          <h1
            class="max-w-2xl mx-auto px-4 text-center mb-4 mb-xl-5"
          >{{ $t('Chào mừng bạn tham gia Circle') }}</h1>

          <div class="pb-4">
            <b-card
              :set="c = circles"
              header-tag="header"
              header-text-variant="white"
              header-bg-variant=" bg-gradient-to-r from-blue-900 to-blue-300"
              header-class="py-3"
              class="shadow-lg"
            >
              <template #header class="py-10">
                <h2 class="mb-0 text-xl xl:text-3xl">{{ c && c.circle_name }}</h2>
              </template>
              <div>
                <b-row class="g-0">
                  <b-col
                    md="4"
                    order-lg="last"
                    class="border-l-0 lg:border-l-2 border-t-0 border-r-0 border-b-0 border-solid border-gray-200 ps-lg-4"
                  >
                    <div class="md:sticky md:top-6">
                      <div class="w-16 h-16 rounded-full overflow-hidden mb-2 mb-lg-4">
                        <b-card-img
                          v-if="c && c.avatar"
                          :src="getImageURL(c && c.avatar)"
                          :alt="c && c.seed_name"
                          class="h-full object-cover"
                        ></b-card-img>
                        <div v-if="c && !c.avatar" class="flex w-full h-full bg-pri text-white">
                          <span class="m-auto text-2xl">{{ (c && nameAvatar) || "-" }}</span>
                        </div>
                      </div>
                      <div class="mb-4 mb-lg-0">
                        <h4>{{ c && c.seed_name }}</h4>
                        <div class="italic">{{ c && c.seed_position }}</div>
                      </div>
                    </div>
                  </b-col>
                  <b-col md="8" order-lg="first" class="flex flex-col pe-lg-4">
                    <div class="mb-3 whitespace-pre-wrap" v-html="c && c.description" />
                    <div class="mt-auto text-lg-center sticky bottom-6">
                      <button
                        type="button"
                        class="btn bg-pri text-white px-5 w-full lg:w-auto"
                        @click.stop="joinCircle"
                      >
                        <span>Tham gia Circle</span>
                      </button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </div>
        </div>
      </div>
      <div v-if="step === 2" class="w-full">
        <Login isBackStep @setStep="setStep" />
      </div>
    </div>
    <div v-else>
      <Error404 />
    </div>
  </div>
</template>

<script>
import backgroundImg from '../../assets/bg1.jpg'
import appUtils from '../../utils/appUtils'
import Login from '../User/Login.vue'
import Error404 from '../404.vue'

export default {
  name: 'CircleJoin',
  components: {
    Login,
    Error404
  },
  data () {
    return {
      code: this.$route.query?.cc || '',
      loading: false,
      circles: null,
      appUtils,
      backgroundImg,
      lang: 'vi',
      show_mini_nav: false,
      step: 1
    }
  },
  async created () {
    await this.getCircles()
  },
  computed: {
    isShowLogo () {
      if (this.$route.meta.layout !== 'auth') {
        return true
      } else {
        return false
      }
    },
    nameAvatar () {
      const strArr = this.circles?.seed_name?.split(' ')
      const name = strArr.slice(-1)[0]
      return name.charAt(0)
    }
  },
  methods: {
    async getCircles () {
      const self = this
      const params = {
        code: this.code
      }
      await this.$rf
        .getRequest('GuestRequest')
        .getCircleInfoByCode(params)
        .then(res => {
          if (res?.data?.code === 200009) {
            self.circles = null
            this.$toast.open({
              message: this.$t(`message_errors.${res?.data?.message}`),
              type: 'error'
            })
          } else {
            self.circles = res?.data
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          self.loading = false
        })
    },
    getImageURL (path) {
      return appUtils.getDocumentURL(path)
    },
    async joinCircle () {
      const self = this
      if (this.loading) return
      if (!this.circles) return

      if (!this.$user) {
        this.loading = false
        window.$toast.open({
          message: this.$t('Bạn cần đăng nhập/đăng ký để tiếp tục gửi yêu cầu'),
          type: 'info'
        })

        this.setStep(2)
        this.$targetRoute = `/${window.location.hash}`
        // this.$router.push({ name: 'Login' })

        return false
      }

      this.loading = true
      await this.$rf
        .getRequest('AuthRequest')
        .joinCircle(this.circles.id)
        .then(result => {
          if (!result.data) return
          window.$toast.open({
            message: this.$t('Bạn đã gửi yêu cầu thành công'),
            type: 'success'
          })
          this.$router.replace({
            name: 'CircleList'
          })
        })
        .catch(() => {
          // console.log(err)
        })
        .finally(() => {
          self.loading = false
        })
    },
    setStep (value) {
      this.step = value || 1
    },
    changeLang (code) {
      const self = this
      const l = code
      console.log(l)
      if (l && (l === 'vi' || l === 'en')) {
        appUtils.setLocalLang(l)
      } else {
        appUtils.setLocalLang('vi')
        self.lang = 'vi'
      }
      window.location.reload()
    },
    actionLogin () {
      this.$targetRoute = `/${window.location.hash}`

      // eslint-disable-next-line no-unused-expressions
      this.$user ? this.onLogout() : this.setStep(2)
    },
    // onLogin () {
    //   this.$router.push({ path: '/login' }).catch(() => {})
    // },
    onLogout () {
      const r = confirm('Bạn có chắc chắn muốn đăng xuất?')
      if (!r) return
      appUtils.removeLocalUser()
      appUtils.removeLocalToken()
      this.$user = null
      // setTimeout(() => {
      //   this.onLogin()
      // }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .nav-item a,
  .navbar select {
    color: #5d5d5d !important;
  }
  .nav-item a {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .nav-item a.active {
    background-color: #e7eaf5;
    color: #121212 !important;
    border-radius: 10px;
  }
  .logo-nav {
    padding-left: 56px;
  }
  .dropdown-pull-right {
    float: right !important;
    right: 0;
    left: auto;
  }

  .dropdown-pull-right > .dropdown-menu {
    right: 0;
    left: auto;
  }
  .dropdown-item {
    color: #292d32 !important;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    object-fit: cover;
  }
  @media only screen and (max-width: 992px) {
    .hide-less-lg {
      display: none;
    }
  }
  .dropdown-toggle::after {
    display: none;
  }
  .mini-nav {
    position: absolute;
    top: 100;
    background: #fff;
    height: calc(100vh - 60px);
    width: 100vw;
    z-index: 99;
  }
  .trans-fade {
    transition: all 0.1s ease;
  }
  .dropdown-menu {
    width: 350px !important;
  }
  .dropdown-menu li a {
    white-space: normal;
  }
  .z-index {
    z-index: 999;
  }
}
</style>
